import React from 'react';
import { useTranslation } from 'react-i18next';

import { greyP4, greyP5 } from '../../theme.ts';

interface ProjectContextMenuProps {
  x: number;
  y: number;
  onClose: () => void;
  itemId: number;
  itemType: 'project' | 'folder';
  onOpenDeleteModal: () => void;
  onOpenMoveModal: () => void;
  onOpenRenameModal: () => void;
  onOpenFolder?: () => void;
  isAdmin?: boolean;
  onSetAsTemplate?: () => void;
}

interface ContextMenuItem {
  label: string;
  action: () => void;
}

const ProjectContextMenu: React.FC<ProjectContextMenuProps> = ({
  x,
  y,
  onClose,
  itemId,
  itemType,
  onOpenDeleteModal,
  onOpenMoveModal,
  onOpenRenameModal,
  onOpenFolder,
  isAdmin = false,
  onSetAsTemplate,
}) => {
  const { t } = useTranslation();

  const menuItems =
    itemType === 'folder'
      ? [
          { label: t('common.open'), action: onOpenFolder || (() => (window.location.href = `?folderId=${itemId}`)) },
          { label: t('common.rename'), action: onOpenRenameModal },
          { label: t('common.delete'), action: onOpenDeleteModal },
        ]
      : [
          { label: t('common.open'), action: () => (window.location.href = `/workspace?projectId=${itemId}`) },
          { label: t('common.rename'), action: onOpenRenameModal },
          { label: t('common.move'), action: onOpenMoveModal },
          ...(isAdmin && onSetAsTemplate ? [{ label: t('projects.setAsTemplate'), action: onSetAsTemplate }] : []),
          { label: t('common.delete'), action: onOpenDeleteModal },
        ];

  const handleItemClick = (item: ContextMenuItem) => {
    item.action();
    onClose();
  };

  return (
    <>
      <div className="fixed inset-0 z-40" onClick={onClose} />

      <div
        className="fixed z-50 rounded-lg shadow-xl py-2"
        style={{
          left: `${x}px`,
          top: `${y}px`,
          width: '200px',
          fontFamily: 'Inter, sans-serif',
          backgroundColor: greyP5,
        }}
      >
        {menuItems.map((item, index) => (
          <React.Fragment key={index}>
            <button
              onClick={() => handleItemClick(item)}
              className="w-full px-5 py-2.5 text-left text-white text-xs font-medium flex items-center justify-between hover:bg-greyP4 transition-colors duration-150"
              onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = greyP4)}
              onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'transparent')}
            >
              <span>{item.label}</span>
            </button>

            {index < menuItems.length - 1 && <div className="border-t" style={{ borderColor: greyP4 }} />}
          </React.Fragment>
        ))}
      </div>
    </>
  );
};

export default ProjectContextMenu;
